import { UsersAndUserGroupsDataModel } from "../UserGroupsManagement/userGroupsManagement";
import { environmentHttpClient } from "../httpClient";

export enum UserLicense {
	Simplify = 1,
	Connect = 2
};

export type UserLicenseStatistics = {
	userLicense: UserLicense;
	regularUserCount: number;
	guestUserCount: number;
};

export type DefaultUserLicenseModel = {
	defaultLicense: UserLicense;
};

export type DefaultUserLicenseSaveModel = {
	defaultLicense: UserLicense;
};

export function getStatistics(signal?: AbortSignal): Promise<readonly UserLicenseStatistics[]> {
	return environmentHttpClient.get<readonly UserLicenseStatistics[]>(
		"/UiApi/FeaturePackageManagement/Statistics",
		undefined,
		{ signal }
	);
}

export function getDefaultLicense(signal?: AbortSignal): Promise<DefaultUserLicenseModel> {
	return environmentHttpClient.get<DefaultUserLicenseModel>(
		"/UiApi/FeaturePackageManagement/Default",
		undefined,
		{ signal }
	);
}

export function setDefaultLicense(model: DefaultUserLicenseSaveModel, signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.put<void>(
		"/UiApi/FeaturePackageManagement/Default",
		model,
		{ signal }
	);
}

export type SetUserLicenseAudienceUserGroupAudience = { userGroupIds: readonly number[]; };
export type SetUserLicenseAudienceUserAudience = { userIds: readonly number[]; };

export type SetUserLicenseAudience =
	| SetUserLicenseAudienceUserAudience
	| SetUserLicenseAudienceUserGroupAudience;

export type SetUserLicenseForUsersModel = {
	userLicense: UserLicense;
	audience: SetUserLicenseAudience;
};

export function setUserLicenseForUsers(model: SetUserLicenseForUsersModel, signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.put<void>(
		"/UiApi/FeaturePackageManagement/SetUserLicenses",
		model,
		{ signal }
	);
}

export type UserLicenseViewModel = {
	selectedUserIds: readonly number[];
	allUsersAndUserGroupsData: UsersAndUserGroupsDataModel;
};

export function getEditViewModel(kind: UserLicense, signal?: AbortSignal): Promise<UserLicenseViewModel> {
	return environmentHttpClient.get<UserLicenseViewModel>(
		`/UiApi/FeaturePackageManagement/${kind}`,
		undefined,
		{ signal }
	);
}
